<div class="fixed z-50 h-fit right-0 bottom-[25px] md:right-6 left-0 mx-auto md:mx-0 md:left-auto">
  <div class="flex flex-col h-fit gap-2 w-screen px-[18px] md:w-[18.8rem] md:p-0">
    @for (alert of alertStore.Alerts(); track alert.id) {
    <app-alert [alert]="alert"></app-alert>
    }
  </div>
</div>